import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import Enum from '../../../utilities/Enum';

export const WEB_PROXY_NO_PROXY_OPTION = 'webProxyNone';
export const WEB_PROXY_MANUAL_PROXY_OPTION = 'webProxyManual';
export const WEB_PROXY_AUTO_PROXY_OPTION = 'webProxyAuto';
export const WEB_PROXY_OPTIONS = {
    [WEB_PROXY_NO_PROXY_OPTION]: i18n._(t`No Proxy`),
    [WEB_PROXY_MANUAL_PROXY_OPTION]: i18n._(t`Manual Proxy`),
    [WEB_PROXY_AUTO_PROXY_OPTION]: i18n._(t`Proxy Auto-Configuration`),
};

export const WEB_PROXY_FIELD = 'globalWebProxy';
export const WEB_PROXY_ID_FIELD = `${WEB_PROXY_FIELD}._id`;
export const WEB_PROXY_SELECTION_FIELD = `${WEB_PROXY_FIELD}.webProxySelection`;
export const WEB_PROXY_MANUAL_SERVER_ADDRESS = `${WEB_PROXY_FIELD}.webProxyAddress`;
export const WEB_PROXY_MANUAL_PORT = `${WEB_PROXY_FIELD}.webProxyPort`;
export const WEB_PROXY_AUTO_URL = `${WEB_PROXY_FIELD}.webProxyAutoconfigUrl`;
export const WEB_PROXY_USERNAME = `${WEB_PROXY_FIELD}.encryptedWebProxyUsername.value`;
export const WEB_PROXY_PASSWORD = `${WEB_PROXY_FIELD}.encryptedWebProxyPassword.value`;

export const BEACON_PACKETS_FIELD = 'beaconPackets';
export const SINGLE_SEM_FIELD = 'singleSEM';
export const PACKET_CAPTURE_DECRYPTION_FIELD = 'packetCaptureDecryption';
export const AGENT_VIRTUAL_INTERFACE_FIELD = 'agentVirtualInterfaceConfig';
export const AGENT_VIRTUAL_INTERFACE_WIRED_FIELD = `${AGENT_VIRTUAL_INTERFACE_FIELD}.virtualWiredInterfaceEnabled`;
export const AGENT_VIRTUAL_INTERFACE_WIRED_COUNT_FIELD = `${AGENT_VIRTUAL_INTERFACE_FIELD}.virtualWiredInterfaceCount`;
export const AGENT_VIRTUAL_INTERFACE_WIRELESS_FIELD = `${AGENT_VIRTUAL_INTERFACE_FIELD}.virtualWirelessInterfaceEnabled`;
export const AGENT_VIRTUAL_INTERFACE_WIRELESS_COUNT_FIELD = `${AGENT_VIRTUAL_INTERFACE_FIELD}.virtualWirelessInterfaceCount`;
export const AGENT_SEM_DESTINATION_DEVICE_TYPE = `semDestinationDeviceType`;
export const AGENT_BEACON_PACKETS_INTERFACES_DISABLED_OPTION = '0';

export const AGENT_XMS_LOCATION_FIELD = 'xmsLocation';
export const AGENT_XMS_HOST_FIELD = 'host';

export const AGENT_WEB_UI_FIELD = 'agentWebUI';
export const AGENT_WEB_UI_SELECTION_FIELD = `${AGENT_WEB_UI_FIELD}.selection`;
export const AGENT_WEB_UI_USERNAME_FIELD = `${AGENT_WEB_UI_FIELD}.username`;
export const AGENT_WEB_UI_PASSWORD_FIELD = `${AGENT_WEB_UI_FIELD}.password`;
export const AGENT_WEB_UI_USERNAME_VALUE_FIELD = `${AGENT_WEB_UI_FIELD}.username.value`;
export const AGENT_WEB_UI_PASSWORD_VALUE_FIELD = `${AGENT_WEB_UI_FIELD}.password.value`;
export const AGENT_WEB_UI_SELECTION_ENABLED_OPTION = 'enabled';
export const AGENT_WEB_UI_SELECTION_DISABLED_OPTION = 'disabled';
export const AGENT_WEB_UI_SELECTION_ENABLED_CREDS_OPTION = 'enabledWithCreds';
export const AGENT_WEB_UI_SELECTION_OPTIONS = {
    [AGENT_WEB_UI_SELECTION_ENABLED_OPTION]: t`Managed on each nPoint`,
    [AGENT_WEB_UI_SELECTION_DISABLED_OPTION]: t`Disabled on all nPoints`,
    [AGENT_WEB_UI_SELECTION_ENABLED_CREDS_OPTION]: t`Enabled on all nPoints`,
};

export const AGENT_SSH_FIELD = 'agentSSH';
export const AGENT_SSH_SELECTION_FIELD = `${AGENT_SSH_FIELD}.selection`;
export const AGENT_SSH_PASSWORD_FIELD = `${AGENT_SSH_FIELD}.password`;
export const AGENT_SSH_PASSWORD_VALUE_FIELD = `${AGENT_SSH_FIELD}.password.value`;
export const AGENT_SSH_SELECTION_ENABLED_OPTION = 'enabledAgent';
export const AGENT_SSH_SELECTION_DISABLED_OPTION = 'disabled';
export const AGENT_SSH_SELECTION_ENABLED_NGP_OPTION = 'enabledNGP';
export const AGENT_SSH_SELECTION_ENABLED_NGP_KEY_OPTION = 'enabledNGPKey';
export const AGENT_SSH_SELECTION_OPTIONS = {
    [AGENT_SSH_SELECTION_ENABLED_OPTION]: t`Managed on each nPoint`,
    [AGENT_SSH_SELECTION_DISABLED_OPTION]: t`Disabled on all nPoints`,
    [AGENT_SSH_SELECTION_ENABLED_NGP_OPTION]: t`Enabled on all nPoints`,
    [AGENT_SSH_SELECTION_ENABLED_NGP_KEY_OPTION]: t`Enable key based access (root) on all nPoints`,
};
export const AGENT_SSH_KEY_ID_FIELD = 'agentSSHKeyId';
export const AGENT_SSH_PASSPHRASES_FIELD = 'agentSSHPassphrase';
export const AGENT_SSH_KEY_CREATED_AT_FIELD = 'agentSSHKeyCreatedAt';

export const AGENT_SNMP_FIELD = 'agentSnmp';
export const AGENT_SNMP_ENABLED_FIELD = `${AGENT_SNMP_FIELD}.enabled`;
export const AGENT_SNMP_COMMUNITY_FIELD = `${AGENT_SNMP_FIELD}.community`;
export const AGENT_SNMP_COMMUNITY_VALUE_FIELD = `${AGENT_SNMP_COMMUNITY_FIELD}.value`;
export const AGENT_SNMP_TARGET_2KH_FIELD = `${AGENT_SNMP_FIELD}.target2kH`;
export const AGENT_SNMP_TARGET_3KH_FIELD = `${AGENT_SNMP_FIELD}.target3kH`;
export const AGENT_SNMP_TARGET_EDGE_FIELD = `${AGENT_SNMP_FIELD}.targetEdge`;
export const AGENT_SNMP_V3_FIELD = `${AGENT_SNMP_FIELD}.v3`;
export const AGENT_SNMP_V3_ENABLED_FIELD = `${AGENT_SNMP_V3_FIELD}.enabled`;
export const AGENT_SNMP_V3_USER_FIELD = `${AGENT_SNMP_V3_FIELD}.user`;
export const AGENT_SNMP_V3_AUTH_FIELD = `${AGENT_SNMP_V3_FIELD}.auth`;
export const AGENT_SNMP_V3_AUTH_CIPHER_FIELD = `${AGENT_SNMP_V3_AUTH_FIELD}.cipher`;
export const AGENT_SNMP_V3_AUTH_PASSWD_FIELD = `${AGENT_SNMP_V3_AUTH_FIELD}.password`;
export const AGENT_SNMP_V3_AUTH_PASSWD_VALUE_FIELD = `${AGENT_SNMP_V3_AUTH_PASSWD_FIELD}.value`;
export const AGENT_SNMP_V3_PRIV_FIELD = `${AGENT_SNMP_V3_FIELD}.priv`;
export const AGENT_SNMP_V3_PRIV_CIPHER_FIELD = `${AGENT_SNMP_V3_PRIV_FIELD}.cipher`;
export const AGENT_SNMP_V3_PRIV_PASSWD_FIELD = `${AGENT_SNMP_V3_PRIV_FIELD}.password`;
export const AGENT_SNMP_V3_PRIV_PASSWD_VALUE_FIELD = `${AGENT_SNMP_V3_PRIV_PASSWD_FIELD}.value`;
export const AGENT_SNMP_V3_AUTH_CIPHER_OPTIONS = Enum.proxy({
    None_: 'None',
    MD5_: 'HMAC-MD5',
    SHA_: 'HMAC-SHA',
    'SHA-256_': 'HMAC-SHA256',
    getDefault: () => t`None`,
});
export const AGENT_SNMP_V3_PRIV_CIPHER_OPTIONS = Enum.proxy({
    // net-snmp 5.9.1 supports: DES|AES|AES-192|AES-256, but 490 doesn't support all of them
    None_: 'None',
    AES128_: 'AES-128',
    AES192_: 'AES-192',
    AES256_: 'AES-256',
    getDefault: () => t`None`,
});
export const AGENT_SNMP_V3_TARGET_EDGE_FIELD = `${AGENT_SNMP_V3_FIELD}.targetEdge`;

export const AGENT_PREFER_IPV6_FIELD = `agentPreferIpv6`;
export const AGENT_GLOBAL_WIRED_AUTH_ENABLED = `wiredAuthenticationGlobal`;

export const SEM_INFINISTREAM_DESTINATION_OPTION = 'Infinistream';
export const SEM_EDGE_COLLECTOR_DESTINATION_OPTION = 'Edge';
export const SEM_INFINISTREAM_DESTINATION = 'ISNG/vSTREAM';
export const SEM_EDGE_COLLECTOR_DESTINATION = 'Edge Collector';
export const SEM_DESTINATION_DEVICE_TYPES = {
    [SEM_INFINISTREAM_DESTINATION_OPTION]: SEM_INFINISTREAM_DESTINATION,
    [SEM_EDGE_COLLECTOR_DESTINATION_OPTION]: SEM_EDGE_COLLECTOR_DESTINATION,
};
